import BaseServiceCrud from './BaseServiceCrud';

export default class ActionService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'challenge-manage';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            type: criteria.type,
            hide_expired: criteria.hideExpired,
            locale: criteria.locale,
            title: criteria?.title,
            coinsFrom: criteria?.coinsFrom,
            coinsTo: criteria?.coinsTo,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    remove(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publishToCompanies(id, request) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}/companies`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getActionsReferences(localizationType, challengeId) {
        return this.fetch(
            `${this.domain}/${this.path}/actions-reference/${localizationType}${
                challengeId !== null && challengeId !== undefined ? `?challengeId=${challengeId}` : ''
            }`,
            {
                method: 'GET',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getLocalizedEnumListForChallengesOrAchievements(enumName, type) {
        return this.fetch(`${this.domain}/${this.path}/list/${enumName}/localized/${type}`, {
            method: 'GET',
        }).then((res) => {
            const result = [];
            res.values.forEach((el) => {
                result.push({label: el.label, enumValue: el.value});
            });
            return Promise.resolve(result);
        });
    }

    getTransportReferences(challengeId) {
        return this.fetch(
            `${this.domain}/${this.path}/transport-reference/${
                challengeId !== null && challengeId !== undefined ? `?challengeId=${challengeId}` : ''
            }`,
            {
                method: 'GET',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }
}
